/**
 * routeGuard — Route classification helpers (Spec 014 S15).
 *
 * Determines whether a given path is publicly accessible without authentication.
 * The /share/:token route must bypass the auth guard (E9: no login required for Public links).
 */

/**
 * Returns true if the given route path is accessible without authentication.
 * A path is public when it matches the /share/:token pattern (one non-empty segment).
 *
 * @example
 *   isPublicPath('/share/abc123')  // true
 *   isPublicPath('/share/')        // false — empty token
 *   isPublicPath('/documents')     // false
 *   isPublicPath('/login')         // false — login itself is not a "public share" path
 */
export function isPublicPath(path: string): boolean {
  // /share/:token — one non-empty segment, no /api/v1/ prefix (Spec 014 E9, S15)
  return /^\/share\/[^/]+$/.test(path);
}
